const certItems = [
  {
    icon: 'ri-shield-check-line',
    title: '古物商許可',
    detail: '福岡県公安委員会',
    number: '901012610013',
    description: '古物営業法に基づく古物商の許可を取得しています。適正な買取業務を行うために必要な許可証です。',
  },
  {
    icon: 'ri-bank-line',
    title: '取引銀行',
    detail: '三井住友銀行',
    number: '',
    description: '信頼性の高い大手銀行との取引により、安全・安心な資金決済をご提供します。',
  },
  {
    icon: 'ri-building-line',
    title: '資本金',
    detail: '200万円',
    number: '',
    description: '適正な事業規模のもと、健全な企業運営を行っております。',
  },
  {
    icon: 'ri-shield-user-line',
    title: '個人情報保護',
    detail: '適切な管理体制',
    number: '',
    description: 'お客様からお預かりする個人情報は、適切に管理し、第三者への提供は行いません。',
  },
];

export default function LegalCertifications() {
  return (
    <section id="legal" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-16">
          <span className="text-xs tracking-[0.3em] text-primary font-medium uppercase mb-3">Legal &amp; Certifications</span>
          <h2 className="text-4xl md:text-5xl font-serif text-primary mb-4">許認可・法的情報</h2>
          <div className="w-16 h-0.5 bg-primary/30 mx-auto mb-4"></div>
          <p className="text-sm text-gray-500 max-w-xl mx-auto">
            株式会社BotaNは関係法令を遵守し、適正な事業運営を行っております。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {certItems.map((item) => (
            <div key={item.title} className="bg-primary-pale rounded-2xl p-7">
              <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-full mb-5">
                <i className={`${item.icon} text-primary text-xl`}></i>
              </div>
              <h3 className="font-semibold text-gray-800 mb-1">{item.title}</h3>
              <p className="text-primary text-sm font-medium mb-1">{item.detail}</p>
              {item.number && (
                <p className="text-xs text-gray-400 font-mono mb-3">{item.number}</p>
              )}
              <p className="text-xs text-gray-500 leading-relaxed mt-3">{item.description}</p>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/50d61053cd5b14a7f9ef4b4b4990dca1.jpg"
            alt=""
            className="w-full h-56 object-cover object-center"
          />
          <div className="absolute inset-0 bg-primary/75"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <h3 className="text-white text-2xl md:text-3xl font-serif font-semibold mb-3">
              まずはお気軽にご相談ください
            </h3>
            <p className="text-white/70 text-sm mb-6">査定・出張費は一切無料。お電話・メールでいつでもご連絡ください。</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:092-577-9739"
                className="flex items-center gap-2 bg-white text-primary px-7 py-3 rounded-full text-sm font-semibold hover:bg-primary-pale transition-colors cursor-pointer whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-xs"></i>
                </div>
                092-577-9739
              </a>
              <button
                onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="border border-white/60 text-white px-7 py-3 rounded-full text-sm font-medium hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                フォームで相談する
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
